import React, { forwardRef } from 'react';
import { BreakpointModalStyled, CloseButton, ModalHeading } from './BreakpointModal.styled';
import { JSX } from '@ionic/core/components';
import { closeCircleOutline, closeOutline } from 'ionicons/icons';

type BreakpointModalProps = {
  heading?: string | null;
  closeButton?: boolean;
  closeButtonStyle?: 'circular' | 'linear';
  onDidDismiss: () => void;
  fullWidth?: boolean | null;
  modalHeight?: string;
  children?: React.ReactElement | React.ReactElement[];
  isSubscription?: boolean;
} & JSX.IonModal;

const BreakpointModal = forwardRef<HTMLIonModalElement, BreakpointModalProps>(
  (
    { heading, fullWidth, modalHeight, closeButton = true, closeButtonStyle = 'linear', isSubscription, ...props },
    ref
  ) => {
    return (
      <BreakpointModalStyled
        {...props}
        ref={ref}
        fullWidth={fullWidth}
        modalHeight={modalHeight}
        backdropDismiss={true}
      >
        {heading && (
          <ModalHeading className={`${isSubscription ? 'light' : ''}`}>
            <h4>{heading}</h4>
          </ModalHeading>
        )}
        {closeButton && (
          <CloseButton
            className={`${isSubscription ? 'bigger' : ''}`}
            icon={closeButtonStyle === 'circular' ? closeCircleOutline : closeOutline}
            onClick={() => props.onDidDismiss()}
          />
        )}
        {props.children}
      </BreakpointModalStyled>
    );
  }
);

export default BreakpointModal;
